import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect } from "react";
import * as Blog from "./Esg-guide-blog-styles";

const BlogList = ({ blogList }) => {
  const router = useRouter();

  const moveToDetail = (id) => {
    router.push(`/esg-guide/post/${id}`);
  };

  return (
    <>
      {blogList?.map((item, i) => (
        <Blog.ArticleBox
          className={
            "col-xl-4 col-lg-6 col-md-6 text-center hover-up mb-30 animated"
          }
          key={i}
          onClick={() => moveToDetail(item.id)}
        >
          <Link href={`/esg-guide/post/${item.id}`}>
            <Blog.Thumbnail className="" thumbnail={item.thumbnail}>
              <a>
                <img src={item.thumbnail} alt="tumbnail" />
              </a>
            </Blog.Thumbnail>
          </Link>
          <Blog.InfoBox>
            <Blog.Title>
              <h5 className="post-title mb-10">
                <Link href={`/esg-guide/post/${item.id}`}>
                  <a>{item.title}</a>
                </Link>
              </h5>
            </Blog.Title>
            <Blog.SubTitle className="mb-10">
              <Link href={`/esg-guide/post/${item.id}`}>
                <a className="entry-meta text-secondary">{item.sub_title}</a>
              </Link>
            </Blog.SubTitle>
            <div className="entry-meta font-xs color-grey mt-10 pb-10">
              <div>
                <span className="post-on mr-10">{item.wdate}</span>
              </div>
            </div>
          </Blog.InfoBox>
        </Blog.ArticleBox>
      ))}
    </>
  );
};

export default BlogList;
